export default {
  state: {
    hasSeenPopupSinceLogin:
      localStorage.getItem('hasSeenPopupSinceLogin') || false,
  },
  mutations: {
    setHasSeenPopupSinceLogin(state, hasSeenPopupSinceLogin) {
      localStorage.setItem('hasSeenPopupSinceLogin', hasSeenPopupSinceLogin);
      state.hasSeenPopupSinceLogin = hasSeenPopupSinceLogin;
    },
  },
  actions: {
    setHasSeenPopupSinceLogin({ commit }, hasSeenPopupSinceLogin) {
      commit('setHasSeenPopupSinceLogin', hasSeenPopupSinceLogin);
    },
  },
  getters: {
    hasSeenPopupSinceLogin: state => state.hasSeenPopupSinceLogin,
  },
};
